import * as React from 'react';

import { Layout } from '../Layout';
import * as styles from './TableLayout.css';

interface ITableLayoutProps {
  table: React.ReactNode;
  nextButton: React.ReactNode;
}

export const TableLayout: React.FC<ITableLayoutProps> = ({ table, nextButton }) => (
  <div className={styles['container']}>
    <Layout>{table}</Layout>
    {nextButton}
  </div>
);
